<template>
  <div id="app" v-if="!isCloseAll">
<!--    <img src="./assets/logo.png">-->
    <router-view />
  </div>
</template>

<script>
import navBar from "./store/navBar";
var threshold = 100;
export default {
  name: 'App',
  data(){
    return{
      isCloseAll:false,
    }
  },
  mounted() {
    window.addEventListener('unload',this.saveTabsList)
  },
  methods:{
    saveTabsList(){
      //console.log(document.title);
      window.sessionStorage.setItem("sysTitle",document.title);
      // window.sessionStorage.clear();
      // console.log('刷新页面了',this.$store.state.tabsValue,JSON.stringify(this.$store.state.tabsValue))
      // console.log(this.$store.state.loginUser);
      window.sessionStorage.setItem("tabsValue",JSON.stringify(this.$store.state.tabsValue));
      window.sessionStorage.setItem("loginUser",JSON.stringify(this.$store.state.loginUser.loginUser));
      window.sessionStorage.setItem("navBar",JSON.stringify(this.$store.state.navBar.nav));
    },
    jt(){
      if (window.outerWidth - window.innerWidth > threshold || window.outerHeight - window.innerHeight > threshold) {
        // 刷新页面；
        // window.location.reload()
        // alert('请关闭控制台重新输入地址进入网站');
        clearInterval(this.timer1)
        this.isCloseAll=true;
        this.$store.dispatch("RESET_ALL",{});//重置所有store
        // console.log(this.isCloseAll)
        // window.close();
      }
    }
  },
  created() {
    this.$nextTick(() => {
      document.title=window.sessionStorage.getItem("sysTitle");
      // 禁用右键
      document.oncontextmenu = new Function('event.returnValue=false')
      // 禁用选择
      document.onselectstart = new Function('event.returnValue=false')
      //禁止f12
      // document.onkeydown = new Function('event.returnValue=false')
    })

    // 上面的禁止f12那段代码没有生效，但是加了下面这段就能生效。
    document.onkeydown = function (e) {
      if (e && e.keyCode === 123) {
        e.returnValue = false
        // e.keyCode = 0   //去掉也可以的，倘若要写，则需要setter 以及 getter配合使用，不配合，会报错
        return false
      }
    }
    this.jt();

    this.timer1 = setInterval(()=> {
      //当浏览器窗口宽度或高度与页面的宽度和高度的差值大于100的时候触发页面刷新
      this.jt();
    })
  }
}
</script>

<style>
  html,body,page{
    height: 100%;
  }
#app {

  margin: 0;
  padding: 0;
  height: 100%;
}
  /*dialog  滚动条*/
  .abow_dialog {
    display: flex;
    justify-content: center;
    align-items: Center;
    overflow: hidden;
  }
  .abow_dialog .el-dialog {
    margin: 0 auto !important;
    height: 90%;
    overflow: hidden;

  }
  .abow_dialog .el-dialog .el-dialog__body {
    position: absolute;
    left: 0;
    top: 54px;
    bottom: 0;
    right: 0;
    padding: 0;
    z-index: 1;
    overflow: hidden;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue